<div
  (click)="cardClicked()"
  class="card-container container-fluid"
  [ngClass]="getClasses()"
  [ngStyle]="cardModel.style"
>
  @if (cardModel.displaySelectionBadge) {
    <div class="row selection-badge-row">
      @if (cardModel.isSelected) {
        <div class="col selection-badge">
          <i class="bi bi-check-circle-fill pull-right"></i>
        </div>
      }
    </div>
  }
  <div
    class="card-body row no-margin d-flex justify-content-center align-items-center"
  >
    <div class="row">
      @if (enableSelection && !hideCheckbox) {
        <div class="col-auto d-flex align-items-center">
          <input
            [attr.disabled]="cardModel.preventSelection ? true : null"
            class="card-column-checkbox"
            type="checkbox"
            [checked]="cardModel.isSelected"
          />
        </div>
      }
      <div class="col">
        @if (cardModel.title) {
          <div class="card-title">
            <h3 class="bold-title">{{ cardModel.title }}</h3>
          </div>
        }
        <!--This class is being removed from the card component. Observe for any issues. class="preserve-whitespace"-->
        @if (cardModel.bodyText) {
          <div>
            <label>{{ cardModel.bodyText }}</label>
          </div>
        }
      </div>
    </div>

    @if (cardModel.bodyTextParts) {
      @for (textPart of cardModel.bodyTextParts; track textPart) {
        <div class="row">
          <div class="col centered">
            <label>{{ textPart }}</label>
          </div>
        </div>
      }
    }

    @for (textObj of cardModel.additionalText; track textObj) {
      <div class="row g-0">
        <div class="col" [ngStyle]="textObj.containerStyle">
          <label [ngStyle]="textObj.style">{{ textObj.text }}</label>
        </div>
      </div>
    }
  </div>
</div>
